<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M6 5.5C6 4.67157 6.67157 4 7.5 4H11V20H7.5C6.67157 20 6 19.3284 6 18.5V5.5Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path
    d="M11 4H16.5C17.3284 4 18 4.67157 18 5.5V18.5C18 19.3284 17.3284 20 16.5 20H11"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path d="M8 8H9M8 11H9" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
</svg>
